<template>
	<div>
		<Drawer title="操作环节" :closable="true" v-model="drawerSwitch" :width='300' draggable>
			<Timeline>
				<TimelineItem v-for="item in processFlowData" :value="item.id" :key="item.id">
					<p class="time">{{item.createDate}}</p>
					<p class="content">{{item.operatorName +'：'+ item.operationContent}}</p>
				</TimelineItem>
			</Timeline>
			<div slot="footer">
				<Button @click="this.drawerSwitch = false;">确定</Button>
			</div>
		</Drawer>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'ProcessLog',
		props: ['processFlowData', 'isShow'],
		data() {
			return {
				drawerSwitch:false
			}
		},
		watch:{
			isShow(val){
				this.drawerSwitch = val;
			},
			drawerSwitch(val){
				// 触发一个自定义事件，通知父组件
				this.$emit('update:isShow', val);
			}
		},
		methods: {
		},
		created: function() {},
	}
</script>

<style scoped>
	/deep/ .ivu-select {
		width: auto;
	}
</style>